// import isNil from 'lodash/isNil'
// import populate from 'coact/populate'

export default next => async (ctx) => {
  const { method } = ctx
  if (method === 'GET') return next(ctx)
  const { values } = ctx

  const code = values.code
  const staffName = values.staffName
  console.log('values:', values)
  // generateKey
  values.key = [code, staffName].join('-')
  // assign _ids to Ref fields (Methods II: assign _id to Ref fields before return next)
  values.storeRef = (values.storeRef) ? values.storeRef : null
  console.log('values.storeRef: ', values.storeRef)
  return next(ctx)
}



// WEBPACK FOOTER //
// ./src/views/middlewares/fillStaffKey.js